<template>
  <section class="ai-access-state" role="status">
    <div class="access-mark"><ai-icon :name="copy.icon" /></div>
    <h1>{{ copy.title }}</h1>
    <p v-if="copy.message" class="access-message">{{ copy.message }}</p>
    <p v-if="copy.resetText" class="access-detail">{{ copy.resetText }}</p>
    <button class="ai-primary" :disabled="checking" @click="$emit('retry')">{{ checking ? '正在检查…' : '重新检查' }}</button>
  </section>
</template>
<script>
import AiIcon from '@/components/common/icons/AiIcon.vue'
import { accessState } from '../presentation/access-state'
export default {
  components: { AiIcon },
  props: { block: Object, checking: Boolean },
  computed: { copy() { return accessState(this.block) } }
}
</script>
<style scoped>
.ai-access-state { width:100%;max-width:480px;margin:0 auto;padding:clamp(36px,12vh,112px) 0 24px;text-align:center;box-sizing:border-box; }
.access-mark { width:52px;height:52px;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;border-radius:16px;background:#e9edfc;color:#506aff; }
.access-mark svg { width:28px;height:28px; }
h1 { margin:0;font-size:18px;line-height:28px;font-weight:600;color:#282828; }
p { margin:0;overflow-wrap:anywhere; }
.access-message { margin-top:10px;font-size:14px;line-height:22px;color:#667185; }
.access-detail { margin-top:12px;font-size:12px;line-height:20px;color:#8c95a4; }
button { font-size:14px;line-height:22px;border-radius:14px;margin-top:24px;min-height:44px;min-width:140px;max-width:100%; }
@media (max-height:360px) { .ai-access-state { padding-top:16px; } }
</style>
